import { Box } from '@mui/material';

export const Lab = () => {
    return <Box sx={{ flex: 1 }}></Box>;
};
